export const TYPE = {
    NOT_START: "not_start",
    STARTED: "started",
    ENDED: "ended"
};
export const TIME = {
    FIFTEEN_MINUTES: 900
};
